import type { CategoryId } from '../game/types'
import { SPORT_BY_PREFIX } from '../game/constants'

/**
 * Custom line-art sport marks (stroke = currentColor) — deliberately drawn
 * rather than emoji, so they sit cleanly in the editorial/almanac type system
 * and adapt to either theme.
 */
const PATHS: Record<CategoryId, JSX.Element> = {
  football: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.2l3.4 2.5-1.3 4h-4.2l-1.3-4z" />
      <path d="M12 7.2V4.2M15.4 9.7l2.6-1.1M14.1 13.2l1.7 2.7M9.9 13.2l-1.7 2.7M8.6 9.7L6 8.6" />
    </>
  ),
  nba: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5v17" />
      <path d="M5.4 6.2c2.9 2 2.9 9.6 0 11.6M18.6 6.2c-2.9 2-2.9 9.6 0 11.6" />
    </>
  ),
  tennis: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6 5.4c3.6 2.6 3.6 10.6 0 13.2M18 5.4c-3.6 2.6-3.6 10.6 0 13.2" />
    </>
  ),
  f1: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3.5v3.5M12 17v3.5M3.5 12H7M17 12h3.5" />
    </>
  ),
  mixed: (
    <path d="M12 3.6l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z" />
  ),
}

export function SportIcon({
  sport,
  size = 22,
  className,
}: {
  sport: CategoryId
  size?: number
  className?: string
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[sport]}
    </svg>
  )
}

/** Resolves an event id ("fb-...", "nb-...") to its sport for the icon. */
export function sportOfId(id: string): CategoryId {
  return SPORT_BY_PREFIX[id.slice(0, 2)] ?? 'mixed'
}
